import { JMCButton } from "@components/JMCButton/JMCButton";
import { CMSButtonProps } from "@types";
import classnames from "classnames";
import React from "react";

import style from "./style.module.scss";

interface Props {
    horizontal_alignment: "start" | "center" | "end";
    buttons: CMSButtonProps[];
}

export const ButtonCollection = ({ horizontal_alignment, buttons }: Props): JSX.Element => {
    return (
        <div
            className={classnames(
                style.element,
                style[`horizontal_align_${horizontal_alignment?.toLocaleLowerCase() || "start"}`],
            )}
            data-test-id="button-collection"
        >
            {buttons?.map((button, i) => {
                return (
                    <div className={style.button} key={`button-collection-${i}`}>
                        <JMCButton button={button} />
                    </div>
                );
            })}
        </div>
    );
};

export default ButtonCollection;
